// DEPENDENCIES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';


import Modal from 'react-modal';
import { connect } from 'react-redux';
import ScrollArea from 'react-scrollbar';
import { browserHistory } from 'react-router';
import SVGInline from "react-svg-inline"

// INNER IMPORTS
import ChooseCategory from './Submit/ChooseCategory';
import {isMobile, makeLinkFromString} from '../../utils';
import ServiceForm from './Submit/ServiceForm';
import MusicLiveForm from './Submit/MusicLiveForm';
import MediaAndLinks from './Submit/MediaAndLinks';
import MusicStyles from './Submit/MusicStyles';
import { PlayingOnStageSlider } from '../Elements/Carousels';
import * as userActions from '../../Actions/users';
import { setWarningMessage } from "../../Actions/messages";
import Prices from './Submit/Prices';
import { openPayingMethodsModal, openGeneralMessageModal , getPinsCall, getMapPinsCall, openLoadingModal } from '../../Actions/main';
import { youtube_parser, vimeo_parser, isEmailValid, isPhoneNumberValid, isFBPageUrlValid, capitalize } from '../../utils';
import { ContactBasic } from '../Elements/Inputs';
import { LIVE_MUSIC, SERVICE } from '../../consts';


// svgs
import lightningSvg from '../inlineSVGs/lightningSVG';
import closeCrossSVG from '../inlineSVGs/closeCrossSVG';



import './Submit.css';
import {AnalyticsService} from "../../Services";
import {translateMissingItem} from "../../lang";

const MAX_TITLE_CHARS = 50;

class SubmitModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userShouldEnter: [],
            instruments: []
        };

        this.dateDom = {};
    }

    stopMobilePropagation(event) {
        event.stopPropagation();
    }

    // for now open only on submit
    handleClickAnywhere() {
        //if (!this.props || this.props.token) return;

        // setTimeout(() => {
        //     this.props.openSignupModal({
        //         signupTextType: 'member-notice'
        //     })
        // }, 200);
    }

    componentDidMount() {
        if (isMobile()) {
            document.body.addEventListener("touchmove", this.stopMobilePropagation, {passive: false});
        }
    }

    componentWillUnmount() {
        if (isMobile()) {
            document.body.remove("touchmove", this.stopMobilePropagation);
        }
    }

    componentWillReceiveProps(nextProps) {
        if ((!this.state.loadedPinId || (this.state.loadedPinId !== (nextProps.editPinData || {}).id)) && Object.keys(nextProps.pinDataWaiting || {}).length < 1) {
            this.setState({loadedPinId: (nextProps.editPinData || {})._id});
            if (nextProps.editMode) {
                const editPinData = nextProps.editPinData;
                this.setState({
                    priceFinal: (editPinData.prices && editPinData.prices.price) || 0,
                    priceRangeMin: (editPinData.prices && editPinData.prices.min) || 0,
                    priceRangeMax: (editPinData.prices && editPinData.prices.max) || 0,
                    priceSelected: (editPinData.prices && editPinData.prices.priceType) || 'free',
                    selectedCurrency: (editPinData.prices && editPinData.prices.currency) || 'ILS',
                    images: editPinData.images && editPinData.images.length > 0 ? editPinData.images : [],
                    files: editPinData.files && editPinData.files.length > 0 ? editPinData.files : [],
                    ...editPinData
                });
            } else {
                // reset only on open and close modal - non edit mode
                if ((!this.props.isModalOpen && (nextProps.isModalOpen || (this.props.isModalOpen && !nextProps.isModalOpen)))) {
                    // this use to assigned to 'state' directly in the pass... reason was to reset modal after closing
                    this.stateReset({...nextProps});
                }
            }
        }

        if (!this.props.isModalOpen && nextProps.isModalOpen) {
            setTimeout(() => {
                disableBodyScroll(document.body);
            }, 200)

            // if (!this.props.user || !this.props.user.myPins || this.props.user.myPins.length < 1) {
            //     this.props.getUserPins();
            // }

        } else if (this.props.isModalOpen && !nextProps.isModalOpen) {
            // window.document.body.style.overflow = 'initial';
            clearAllBodyScrollLocks();
        }
    }

    stateReset(props) {
        if (!props) return;

        let category;

        if (props && props.datatypes && props.datatypes.categories && props.datatypes.categories[props.type]) {
            category = props.datatypes.categories[props.type][0].name
        }

        this.setState({
            _id: '',
            id: '',
            type: '',
            images: [],
            files: [], //props.files,
            desc: '',
            category,
            location: '',
            price: 0,
            userShouldEnter: [],
            subCategories: [],
            priceFinal: 0,
            priceRangeMin: 0,
            priceRangeMax: 0,
            priceSelected: 'free',
            selectedCurrency: 'ILS',
            name: '',
            contactInfo: '',
            email: '',
            phone: '',
            fblink: '',
            date: '',
            time: 75600,
            instruments: [],
            video: '',
            video_embed: '',
            ticketLink: '',
            link1: '',
            link2: '',
        })
    }

    // Every time the user changes the email/password field, the state changes accordingly
    updateValue(event) {
        if (event.target.name === 'date') return;
        if (event.target.name === 'name' && event.target.value && event.target.value.length > MAX_TITLE_CHARS) return;
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    updateDate(date) {
        this.setState({date});
    }

    updateTime(time) {
        this.setState({time});
    }

    setPrice(value) {
        this.setState({price: value})
    }

    updateLocation(place) {
        let location = {
            position: {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            }
        };

        // "night_club", "point_of_interest", "establishment"
        // street_address
        // "route"

        const isRevenue = place.types.find(t => (t === 'point_of_interest' || t === 'establishment') && (t !== 'street_address' && t !== 'route'));
        let revenueName = '';

        if (isRevenue) {
            revenueName = place.name;
        }

        place.address_components.forEach((addcomp) => {
            location[addcomp.types[0]] = addcomp.long_name;
        });

        this.setState({
            location: {
                position: {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                },
                state: location.administrative_area_level_1 || location.country,
                country: location.country,
                city: location.locality,
                street: location.route,
                number: parseInt(location.street_number, 10),
                revenueName
            }
        }, () => console.log('loc', this.state.location));
    }

    updateLocationValue() {
        if (this.props.editPinData) {
            let location = this.props.editPinData.location;
            document.getElementById("autocomplete").value = (location.street || '') + (location.number ? (" " + location.number + ", "): " ") + location.city + ", " + location.country;
        }
    }

    selectInstrument(name) {
        let instruments = [...this.state.instruments];
        instruments.push(name);
        this.setState({ instruments });
    }

    unSelectInstrument(name) {
        let instruments = [...this.state.instruments]
        instruments.splice(instruments.indexOf(name),1);
        this.setState({ instruments });
    }

    // 'Hi there!', `You can select up to 3 categories`
    selectSubCategory(subCategory) {
        let subCategories = this.state.subCategories || [];

        let subCategoryIndex = subCategories.indexOf(subCategory);
        if (subCategoryIndex>-1) {
            subCategories.splice(subCategoryIndex,1);

        } else {
            if (subCategories.length === 3) {
                this.props.openGeneralMessageModal(`שלום לך!`, `אפשר לבחור עד 3 קטגוריות`);

                return;
            }

            subCategories.push(subCategory);
        }

        this.setState({ subCategories });
    }

    selectPrices(event) {
        if (event.target.name === 'date') return;

        if (event.target.name === 'priceFinal') {

            this.setState({
                [event.target.name]: parseFloat(event.target.value) || 0,
                priceRangeMin: 0,
                priceRangeMax: 0,
            });

            return
        }

        this.setState({
            [event.target.name]: parseFloat(event.target.value) || 0,
            priceFinal: 0
        })
    }

    handleCloseModal() {
        this.props.closeModal();
    }

    selectPricesByButton(priceType) {
        if (priceType === 'price') {

            this.setState({
                priceRangeMin: (this.props.editPinData && this.props.editPinData.prices && this.props.editPinData.prices.min) || 0,
                priceRangeMax: (this.props.editPinData && this.props.editPinData.prices && this.props.editPinData.prices.max) || 0,
                priceSelected: priceType
            });

            return;
        }

        if (priceType === 'free' || priceType === 'hat') {
            this.setState({
                priceRangeMin: (this.props.editPinData && this.props.editPinData.prices && this.props.editPinData.prices.min) || 0,
                priceRangeMax: (this.props.editPinData && this.props.editPinData.prices && this.props.editPinData.prices.max) || 0,
                priceFinal: (this.props.editPinData && this.props.editPinData.prices && this.props.editPinData.prices.price) || 0,
                priceSelected: priceType
            })
        }

        // this is for price-range
        this.setState({
            priceFinal: (this.props.editPinData && this.props.editPinData.prices && this.props.editPinData.prices.price) ||  0,
            priceSelected: priceType
        })
    }

    onDrop(files) {
        const newFiles = this.state.files || [];
        files.forEach((file)=>{
            if (newFiles.length + (this.state.images ? this.state.images.length : 0) < 5 ) {
                newFiles.push(file);
            }
        });

        this.setState({
            files: newFiles,
            uploadSuccess: files.length
        });
    }

    selectMainMediaImage(index, imageType) {
        if (this.state.images && imageType === 'uploaded') {
            const firstImage = this.state.images[index];
            const newImages = [...this.state.images];
            newImages.splice(index, 1);
            this.setState({images: [firstImage, ...newImages]});

            return;
        }

        if (this.state.files && imageType === 'new') {
            const firstFile = this.state.files[index];
            const newFiles = [...this.state.files];
            newFiles.splice(index, 1);
            this.setState({ files: [firstFile, ...newFiles] });
        }
    }

    removeImage(index, imageType) {
        // remove selected files - not uploaded yet
        if (this.state.files && imageType === 'new') {
            const files = [...this.state.files];
            files.splice(index, 1);
            this.setState({ files });

            return;
        }

        if (this.state.images && imageType === 'uploaded') {
            // remove uploaded images
            const images = [...this.state.images];
            images.splice(index, 1);
            this.setState({ images })
        }
    }

    checkRequired() {
        const required = this.props.type === LIVE_MUSIC ?
            ["name", "location", "date", "time", "subCategories", "instruments"]:
            ["category", "name", "location", "desc"];

        let userShouldEnter = [];
        required.forEach(field => {
            // checking  if location have a street in it
            if (field === 'location' && this.state[field]) {

                if (!this.state[field].street && !this.state[field].revenueName) {
                    userShouldEnter.push('Missing street name');
                }

                return;
            }

            if (this.state[field] === undefined || (this.state[field] &&  this.state[field].length === 0) || this.state[field] === '') {
                if (field === 'subCategories') {
                    userShouldEnter.push('Sub categories');

                    return;
                }

                userShouldEnter.push(field);
            }
        });

        // not contact info check
        if (this.props.type === SERVICE) {
            if (!this.state.phone && !this.state.email && !this.state.fblink) {
                userShouldEnter.push('Phone/Email/FB Link');
            }
        }

        this.setState({ userShouldEnter });
        return userShouldEnter;
    }

    // 'On no!', `Starting price can't be 0 or lower. Select Free or set value above 0`
    checkValidation() {
        if (this.state.priceSelected === 'price-range') {
            if (this.state.priceRangeMin <= 0) {
                this.props.openGeneralMessageModal('אוי לא!', `המחיר ההתחלתי לא יכול להיות 0 או נמוך יותר. בחר בחינם או הגדר ערך מעל 0`);
                return true;
            }

            // 'Oh no!', `Max price can't be lower than Min Price`
            if (this.state.priceRangeMin >= this.state.priceRangeMax) {
                this.props.openGeneralMessageModal('אוי לא!', `המחיר המקסימלי לא יכול להיות נמוך מהמחיר המינימלי`);
                return true
            }
        }

        // 'On no!', `Price can't be 0 or lower. Select Free or set a price above 0`
        if (this.state.priceSelected === 'price' && this.state.priceFinal <= 0) {
            this.props.openGeneralMessageModal('אוי לא!', `המחיר לא יכול להיות 0 או נמוך יותר. בחר בחינם או הגדר מחיר מעל 0`);
            return true;
        }

        if (this.props.type === LIVE_MUSIC) {
            if (this.state.email && !isEmailValid(this.state.email)) {
                alert('כתובת מייל אינה תקינה');

                return true;
            }

            // example to legit FB page: https://www.facebook.com/name.lastname
            // FB validation
            if (this.state.fblink && !isFBPageUrlValid(this.state.fblink)) {
                alert('הלינק של פייסבוק לא תקין');

                return true;
            }
        }

        if (this.props.type === SERVICE) {
            if (this.state.phone && !isPhoneNumberValid(this.state.phone)) {
                alert('מספר הטלפון אינו תקין');

                return true
            }

            if (this.state.email && !isEmailValid(this.state.email)) {
                alert('כתובת מייל אינה תקינה');

                return true;
            }

            if (!this.state.priceFinal && !this.state.priceRangeMin && !this.state.priceRangeMax) {
                alert('יש להגדיר מחיר או טווחי מחירים')
                return true;
            }
            if (this.state.priceFinal && (this.state.priceRangeMin || this.state.priceRangeMax)) {
                alert('לא יכול להיות טווח מחירים ומחיר סופי ביחד');

                return true;
            }
        }
    }

    selectCurrency(selectedCurrency) {
        this.setState({ selectedCurrency });
    }

    chooseCategory(category) {
        if (this.props.editMode) return;

        this.setState({ category, subCategories: [] });

    }

    emptyPricesFix(prices) {
        if (!prices) return;
        if (prices.priceType === 'price-range') {
            if (prices.min === 0) {
                prices.min = 1
            }
        }

        if (prices.priceType === 'price') {
            if (!prices.price || prices.price === 0) {
                prices.price = 1;
            }
        }
    }

    getTitle() {
        return this.props.type === SERVICE ? `צרו את השירות שלכם!` : `צרו את האירוע שלכם!`
        // return `PARTICIPATE: SUBMIT YOUR ${this.props.type === 'service' ? 'SERVICE' : 'LIVE MUSIC'}!`
    }

    getSubTitle() {
        return this.props.type === SERVICE ? `פרסמו את השירות שלכם` : `פרסמו את המופע שלכם`
        // return `PUBLISH YOUR ${this.props.type === SERVICE ? "SERVICE":"SHOW"}`
    }

    goLive() {
        // check if user is logged in and verified
        if (!this.props.user.token) {
            this.props.openSignupModal({
                signupTextType: 'member-notice'
            })

            return
        }

       // if (!this.props.isVerified && this.props.user.token) {
        if (!this.props.isVerified && this.props.user.token) {
            // 'Please confirm your account', 'resendEmail'
            this.props.setWarningMessage('אנא אשר את חשבונך', 'resendEmail');
            return;
        }

        const userShouldEnter = this.checkRequired();
        if (userShouldEnter.length > 0) {

            const displayList = userShouldEnter.map(l => {
                if (l === 'desc') {
                    l = 'description';
                }

                return capitalize(l);
            });

            const translatedList = displayList.map(missingItem => translateMissingItem(missingItem));

            // alert('Those fields must be filled: ' + listMissing);
            // 'Oh no!', 'Some fields are missing:
            this.props.openGeneralMessageModal('אוי לא!', 'חסרים כמה שדות: ', translatedList);

            return;
        }

        if (this.checkValidation()) return;

        let pinObject = {
            id: this.state._id,
            type: this.props.type,
            images: this.state.images,
            desc: this.state.desc,
            category: this.state.category,
            location: this.state.location,
            price: this.state.price || 0,
            prices: {
                currency: this.state.selectedCurrency,
                min: this.state.priceSelected === 'price-range' ? this.state.priceRangeMin : 0,
                max: this.state.priceSelected === 'price-range' ? this.state.priceRangeMax : 0,
                price: this.state.priceSelected === 'price' ? this.state.priceFinal : 0,
                priceType: this.state.priceSelected
            },
            name: this.state.name,
            contactInfo: this.state.contactInfo,
            email: this.state.email,
            phone: this.state.phone,
            fblink: this.state.fblink,
            date: this.state.date,
            time: this.state.time,
            subCategories: this.state.subCategories,
            instruments: this.state.instruments,
            video: this.state.video,
            video_embed: this.state.video ? youtube_parser(this.state.video) || vimeo_parser(this.state.video): null,
            ticketLink: makeLinkFromString(this.state.ticketLink),
            link1: makeLinkFromString(this.state.link1),
            link2: makeLinkFromString(this.state.link2)
        };

        this.emptyPricesFix(pinObject.prices);

        // if this is update pin flow
        if (this.state._id) {
            // TODO: start loading
            this.props.openLoadingModal();
            this.props.getVimeoThumbnail(this.state.video)
                .then(thumbnailUrl => {
                    pinObject.video_thumbnail = thumbnailUrl;
                    this.props.savePin(this.props.token, pinObject, this.state.files);
                    this.props.getPinsCall(this.props.filters);
                    this.props.getMapPinsCall(this.props.filters);
                    this.setState({ submitted: true });
                })
                .catch(err => {
                    this.props.savePin(this.props.token, pinObject, this.state.files);
                    this.props.getPinsCall(this.props.filters);
                    this.props.getMapPinsCall(this.props.filters);
                    this.setState({ submitted: true });
                });


            // if this is new pin
        } else {
            this.props.getVimeoThumbnail(this.state.video)
                .then(thumbnailUrl => {
                    pinObject.video_thumbnail = thumbnailUrl;
                    this.props.submitWaitingLogin(pinObject, this.state.files);

                    // if user not logged in popup a login window
                    // if (!this.props.isLoggedIn) {
                    //     this.props.openSignupModal();
                    //     // this.props.closeModal();
                    //     return;
                    // }

                    // If have an activate plan, submit the pin to server
                    // browserHistory.replace(this.props.route);
                    //this.props.openPayingMethodsModal();

                    browserHistory.push('/packages')
                    this.props.closeModal();

                    this.setState({submitted: true});
                })
                .catch(err => {
                    this.props.submitWaitingLogin(pinObject, this.state.files);

                    // if user not logged in popup a login window
                    // if (!this.props.isLoggedIn) {
                    //     this.props.openSignupModal();
                    //     this.props.closeModal();
                    //     return;
                    // }

                    // If have an activate plan, submit the pin to server
                    this.props.closeModal();
                    browserHistory.push('/packages')
                    // this.props.openPayingMethodsModal();

                    this.setState({submitted: true});
                });

        }

        AnalyticsService.sendEvent(AnalyticsService.events.SUBMIT_AD, `${pinObject.type}_${pinObject.category}`, null, {
            pin_type: pinObject.type,
            pin_category: pinObject.category
        });

    }

    handleDatePopUp() {
        if (this.props.type !== LIVE_MUSIC) return;

        this.dateDom = document.querySelector('.react-datepicker__tether-element');

        if (!this.dateDom || !this.dateDom.style || this.dateDom.style.display === 'none') return;

        this.dateDom.style.display = 'none';
    }

    renderScrollableContent() {
        return (
            <div className="content">
                <div className="mainTitle">
                    {this.getSubTitle()}
                </div>
                <ChooseCategory
                    type={this.props.type}
                    chooseSubmitCategory={(category) => this.chooseCategory(category)}
                    selectedCategory={this.state.category}
                    userShouldEnter={this.state.userShouldEnter}
                    datatypes={this.props.datatypes}
                />
                {this.props.type === SERVICE ?
                    <ServiceForm
                        updateLocation={this.updateLocation.bind(this)}
                        updateValue={this.updateValue.bind(this)}
                        {...this.state}
                    /> :
                    <MusicLiveForm
                        isSignupModalOpen={this.props.user.isSignupModalOpen}
                        updateLocation={this.updateLocation.bind(this)}
                        isLocationMsg={
                            this.state.location &&
                            this.state.location.country &&
                            this.state.location.city &&
                            (!this.state.location.revenuName && !this.state.location.street)
                        }
                        updateValue={this.updateValue.bind(this)}
                        setPrice={this.setPrice.bind(this)}
                        updateDate={this.updateDate.bind(this)}
                        updateTime={this.updateTime.bind(this)}
                        type={this.props.type}
                        {...this.state}
                    />
                }

                <Prices
                    type={this.props.type}
                    onInputChange={(event) => this.selectPrices(event)}
                    priceFinal={this.state.priceFinal}
                    priceMin={this.state.priceRangeMin}
                    priceMax={this.state.priceRangeMax}
                    priceSelect={priceType => this.selectPricesByButton(priceType)}
                    priceSelected={this.state.priceSelected}
                    selectedCurrency={this.state.selectedCurrency}
                    selectCurrency={(currency) => this.selectCurrency(currency)}
                />
                {this.state.category ?
                    <div>
                        <MusicStyles
                            type={this.props.type}
                            category={this.state.category}
                            subCategories={this.state.subCategories || []}
                            selectSubCategory={this.selectSubCategory.bind(this)}
                            userShouldEnter={this.state.userShouldEnter}
                            datatypes={this.props.datatypes}
                        />
                        {this.props.type === LIVE_MUSIC ?
                            <PlayingOnStageSlider
                                type={this.props.type}
                                selectInstrument={item => this.selectInstrument(item)}
                                unSelectInstrument={item => this.unSelectInstrument(item)}
                                selected={this.state.instruments}
                                datatypes={this.props.datatypes}
                            />
                            : null
                        }
                    </div>
                    : null
                }
                <MediaAndLinks
                    type={this.props.type}
                    updateValue={this.updateValue.bind(this)}
                    ticketLink={this.state.ticketLink}
                    video={this.state.video}
                    link1={this.state.link1}
                    link2={this.state.link2}
                    onDrop={files => this.onDrop(files)}
                    uploadSuccess={this.state.uploadSuccess}
                    selectMainImage={(index, imageType) => this.selectMainMediaImage(index, imageType)}
                    removeImage={(index, imageType) => this.removeImage(index, imageType)}
                    files={this.state.files}
                    uploadedImages={this.state.images}
                />
                <ContactBasic
                    type={this.props.type}
                    updateValue={(event) => this.updateValue(event)}
                    email={this.state.email}
                    phone={this.state.phone}
                    fblink={this.state.fblink}
                />
                {this.state._id ?
                    <div className={"goLive " + this.props.type} onClick={()=>this.goLive()}>
                        אישור!
                        <SVGInline svg={lightningSvg} width="25px" fill={this.props.type === 'service' ? '#6a5da8' : '#6dc6b0'}/>
                    </div>:
                    <div className={"goLive " + this.props.type} onClick={()=>this.goLive()}>
                        עלו לאויר!
                        <SVGInline svg={lightningSvg} width="25px" fill={this.props.type === 'service' ? '#6a5da8' : '#6dc6b0'}/>
                    </div>
                }
            </div>
        )
    }

    renderMobileScroll() {
        return (
            <div
                className="area"
                onScroll={event => this.handleDatePopUp(event)}
            >
                {this.renderScrollableContent()}
            </div>
        )
    }

    renderWebScroll() {
        return (
            <ScrollArea
                stopScrollPropagation
                vertical
                speed={2}
                className="area"
                horizontal={false}
                onScroll={event => this.handleDatePopUp(event)}
                verticalContainerStyle={{overflow: 'hidden'}}
                verticalScrollbarStyle={{overflow: 'hidden'}}
            >
                {this.renderScrollableContent()}
            </ScrollArea>
        )
    }

    render() {
        return (
            <div className="submit">
                <Modal
                    isOpen={this.props.isModalOpen}
                    contentLabel="Submit"
                    className="modal-wrapper submitModal rtl"
                    onAfterOpen={this.updateLocationValue.bind(this)}
                    style={{overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0)'
                        }}}
                >
                    <div onClick={() => this.handleCloseModal()} >
                        <SVGInline className="closeButton" svg={closeCrossSVG} component="i"/>
                    </div>
                    <div className={"topTitle " + this.props.type}>
                        {this.getTitle()}
                    </div>
                    {isMobile() ? this.renderMobileScroll() : this.renderWebScroll()}
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    message: state.users.signupMessage,
    type: state.users.submitType,
    token: state.users.token,
    isVerified: state.users.isVerified,
    isLoggedIn: state.users.isLoggedIn,
    editMode: state.users.editMode,
    editPinData: state.users.editPinData,
    filter: state.main.filters,
    pinDataWaiting: state.users.pinDataWaiting,
    datatypes: state.main.datatypes,
    programType: state.users.programType,
    user: state.users,
    route: state.routing.locationBeforeTransitions.pathname
})

SubmitModal.propTypes = {
    type: PropTypes.string,
    closeModal: PropTypes.func,
    isModalOpen: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    savePin: PropTypes.func,
    getVimeoThumbnail: PropTypes.func,
    openPayingMethodsModal: PropTypes.func,
    openLoadingModal: PropTypes.func,
    openGeneralMessageModal: PropTypes.func,
    programType: PropTypes.string,
    submitWaitingLogin: PropTypes.func,
    openSignupModal: PropTypes.func,
    getPinsCall: PropTypes.func,
    getMapPinsCall: PropTypes.func,
    token: PropTypes.string,
    user: PropTypes.object,
    datatypes: PropTypes.object,
    route: PropTypes.string,
    setWarningMessage: PropTypes.func,
    isVerified: PropTypes.bool,
    getUserPins: PropTypes.func
};

// connecting redux state to the component props
export const SubmitModalContainer = connect(mapStateToProps, {...userActions,
    openPayingMethodsModal,
    openGeneralMessageModal,
    getPinsCall,
    getMapPinsCall,
    openLoadingModal,
    setWarningMessage
})(SubmitModal);

export default SubmitModal;

3



// WEBPACK FOOTER //
// ./src/Components/Users/Submit.js